import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      50: '#e3f2fd',
      100: '#bbdefb',
      200: '#90caf9',
      300: '#64b5f6',
      400: '#42a5f5',
      500: '#2196f3',
      600: '#1e88e5',
      700: '#1976d2',
      800: '#1565c0',
      900: '#0d47a1',
    },
    accent: {
      50: '#fff3e0',
      100: '#ffe0b2',
      200: '#ffcc80',
      300: '#ffb74d',
      400: '#ffa726',
      500: '#ff9800',
      600: '#fb8c00',
      700: '#f57c00',
      800: '#ef6c00',
      900: '#e65100',
    },
    logo: '#e5c196',
  },
  styles: {
    global: {
      body: {
        bg: 'gray.900',
        color: 'white',
      },
      '*:focus:not(:focus-visible)': {
        boxShadow: 'none !important',
        outline: 'none !important',
      },
      '*:focus-visible': {
        boxShadow: 'none !important',
        outline: 'none !important',
      },
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'accent',
      },
    },
  },
});

export default theme; 